import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Translate from "../Multilanguage/Translate";
import { authenticate } from "../../network/service";

const ResubscriptionInfo = ({ resubscribe }) => {
    const accessToken = useSelector((state) => state.accessToken?.value);
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const appInfo = {
        accessToken: accessToken,
        projectDetails: projectInfo,
    };
    const [show, setShow] = useState(true);
    const [loading, setLoading] = useState(false);

    const checkSubscription = async () => {
        setLoading(true);
        try {
            const response = await authenticate(appInfo);

            if (response && response?.user_subscription_id) {
                setShow(true);
                return true;
            } else {
                setShow(false);
                return false;
            }
        } catch (err) {
            setShow(false);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const checkAndResubscribe = async () => {
        const subscriptionValid = await checkSubscription();

        if (subscriptionValid) {
            resubscribe();
        } else {
            window.location.href = "/";
        }
    };

    if (loading || !show) return null;

    return (
        <div className="resubscriptionInfo">
            <div className="resubscribeMessage">
                <Translate textKey={'membership_expired'} />
            </div>
            <div
                className="resubscribeButton"
                onClick={checkAndResubscribe}
                style={{
                    backgroundColor: appInfo?.projectDetails?.projectConfig?.config?.BACKGROUND_COLOR,
                    color: appInfo?.projectDetails?.projectConfig?.config?.TEXT_COLOR,
                    border: `1px solid ${appInfo?.projectDetails?.projectConfig?.config?.TEXT_COLOR}`,
                }}
            >
                <Translate textKey={'resubscribe'} />
            </div>
        </div>
    );
};

export default ResubscriptionInfo;
